import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ReactHighcharts from "react-highcharts";
import measureSize from "models/MeasureSize";

class MeasureSize extends React.Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data;
  }

  render() {
    return (
      <Fragment>
        <ReactHighcharts
          config={measureSize(this.props.data, this.props.xCategories)}
        />
      </Fragment>
    );
  }
}
MeasureSize.propTypes = {
  data: PropTypes.arrayOf(PropTypes.number).isRequired,
  xCategories: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default MeasureSize;



// WEBPACK FOOTER //
// ./src/components/ReportDetail/MeasureSize.jsx